import type { ActionType } from 'typesafe-actions';
import { createRoutine } from '../common/utils/new-routines';

export const ssoLoginRoutine = createRoutine('sso/LOGIN')<undefined, string, undefined, undefined, string, undefined>();
export type SSOLoginRoutineActionType = ActionType<typeof ssoLoginRoutine>;
